/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

export const selectBundles = state => state.myPuratos_promotions?.bundles;

export const selectAllBundlesProducts = state => state.myPuratos_promotions?.bundles?.map(bundle => bundle.products);

export const selectBundleForMaterial = (state, materialNumber) => selectBundles(state)?.filter(bundle => bundle.products?.option?.items?.filter(material => material.materialNumber == materialNumber).length !== 0).map(bundle => bundle.products);
